<template>
  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="9"
          >
            <div class="d-flex align-items-center justify-content-end">
              <!-- <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Procurar..."
                debounce="600"
              /> -->
              <b-button
                variant="outline-primary"
                :to="{ name: 'layouts-email-list'}"
              >
                <span class="text-nowrap">Adicionar/Editar Layout de Email</span>
              </b-button>
              <b-button
                variant="primary"
                class="ml-2"
                :to="{ name: 'mensagem-create'}"
              >
                <span class="text-nowrap">Adicionar Mensagem</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refMensagemListTable"
        class="position-relative"
        responsive
        striped
        hover
        :items="fetchMensagens"
        :fields="tableColumns"  
        primary-key="id"
        show-empty
        empty-text="Nenhum registro encontrado"
      >
        <!-- Column: User -->
        <template #cell(titulo)="data">
          <b-link
            class="font-weight-bold d-block text-nowrap" 
          >
            {{ data.item.titulo }}
          </b-link>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            
            <b-dropdown-item :to="{ name: 'mensagem-edit', params: { id: data.item.id } }">
                <feather-icon icon="EditIcon"/>
                <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <div @click="showModalDelete(data.item.id)">
                <feather-icon icon="TrashIcon"/>
                <span class="align-middle ml-50">Excluir</span>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <!-- Paginação -->
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo de {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.total }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="dataMeta.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BPagination, BLink,BDropdown, BDropdownItem
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import useMensagemList from './useMensagemList'
import mensagemStoreModule from '../mensagemStoreModule'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {

    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BButton,
    BLink,
    BDropdown, 
    BDropdownItem,

    vSelect,
  },
  setup() {
    const MENSAGEM_APP_STORE_MODULE_NAME = 'app-mensagem'

    // Register module
    if (!store.hasModule(MENSAGEM_APP_STORE_MODULE_NAME)) store.registerModule(MENSAGEM_APP_STORE_MODULE_NAME, mensagemStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MENSAGEM_APP_STORE_MODULE_NAME)) store.unregisterModule(MENSAGEM_APP_STORE_MODULE_NAME)
    })

    function showModalDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Você deseja prosseguir com a exclusão?', {
          title: 'Confirme sua ação',
          size: 'sm',
          modalClass: 'modal-danger',
          okVariant: 'danger',
          okTitle: 'Sim, confirmar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if(value == true){
            axios.delete('mensagens/'+id)
            .then((response) => {
              this.$refs.refMensagemListTable.refresh();
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Exclusão de registro',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: `Mensagem excluída com sucesso!`,
                },
              })
            }).catch(error => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Exclusão de registro',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: `Não foi possível excluir sua mensagem ):`,
                },
              })
            });
          }
        })
    }

    const {
      fetchMensagens,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refMensagemListTable,
      refetchData,

    } = useMensagemList()

    return {

      fetchMensagens,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refMensagemListTable,
      refetchData,
      showModalDelete
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
